export default __webpack_public_path__ + "static/media/eliqx-logo-all-grey.0f40b487.svg";